import { Component, inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SicotService } from '../sicot.service';
import { CotAdminUser } from '../types/CotAdminUser';
import { Cot } from '../types/Cot';
import { CommonModule } from '@angular/common';

export interface CollegaCotDialogData {
  user: CotAdminUser;
}

@Component({
  selector: 'app-collega-cot-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './collega-cot-dialog.component.html',
  styleUrl: './collega-cot-dialog.component.css',
})
export class CollegaCotDialogComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<CollegaCotDialogComponent>);
  private readonly data = inject<CollegaCotDialogData>(MAT_DIALOG_DATA);
  private readonly sicot = inject(SicotService);

  user: CotAdminUser = this.data.user;
  allCots: Cot[] = [];
  selectedCotIds: Set<number> = new Set();
  loading = true;
  saving = false;
  errorMessage: string | null = null;

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.errorMessage = null;
    this.sicot.getCots().subscribe({
      next: (cots) => {
        this.allCots = cots ?? [];
        this.sicot.getUserCots(this.user.id).subscribe({
          next: (userCots) => {
            this.selectedCotIds = new Set((userCots ?? []).map((c) => c.id));
            this.loading = false;
          },
          error: () => {
            this.selectedCotIds = new Set();
            this.loading = false;
          },
        });
      },
      error: () => {
        this.loading = false;
        this.errorMessage = 'Errore nel caricamento delle COT';
      },
    });
  }

  isSelected(cot: Cot): boolean {
    return this.selectedCotIds.has(cot.id);
  }

  toggle(cot: Cot): void {
    if (this.selectedCotIds.has(cot.id)) {
      this.selectedCotIds.delete(cot.id);
    } else {
      this.selectedCotIds.add(cot.id);
    }
    this.selectedCotIds = new Set(this.selectedCotIds);
  }

  save(): void {
    this.saving = true;
    this.errorMessage = null;
    this.sicot.setUserCots(this.user.id, Array.from(this.selectedCotIds)).subscribe({
      next: () => this.dialogRef.close(true),
      error: (err) => {
        this.saving = false;
        this.errorMessage = err?.error?.message ?? err?.message ?? 'Errore nel salvataggio';
      },
    });
  }
}
